import YellowBox from "components/ui_components/YellowBox";
import React from "react";
import Image from "next/image";
import marketingImg from "public/images/marketing-img.png";
import yellowEllipse from "public/images/yellow-ellipse.svg";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import MarketingImage from "components/customImages/MarketingImage";
import { h2FontSize } from "utils/common";

function Marketing() {
  const { t: translate } = useTranslation("marketing");

  return (
    <section className="bg-white rounded-[21px] xl:rounded-[54px] mx-3 py-14 px-9 lg:px-24 xl:px-36 md:grid md:place-items-center md:gap-10 md:grid-cols-2">
      <div className="grid gap-6 lg:gap-8 xl:gap-11">
        <div className="grid gap-6 lg:gap-8 xl:gap-14">
          <YellowBox />
          <h2
            className={`${h2FontSize} text-blue font-bold leading-7 lg:leading-9 xl:leading-tight ltr:text-left rtl:text-right`}
          >
            {translate("heading")}
          </h2>
        </div>

        <div className="grid gap-6 lg:gap-8">
          <MarketingImage
            imageName={"Home-image.png"}
            alt="search-img"
            className={`md:hidden `}
            key="Home-image.png"
          />
          <p className="font-light text-base lg:text-lg xl:text-2xl leading-7 lg:leading-8 text-darkGrey">
            {translate("description")}
          </p>
        </div>

        <div className="grid gap-6 lg:gap-8 xl:gap-11">
          <div className="grid gap-3 lg:gap-4 xl:gap-5">
            <p className="flex flex-row items-center gap-2 lg:gap-3 xl:gap-[10px]">
              <Image
                src={yellowEllipse}
                alt="icon"
                height={13}
                width={13}
                className="w-3 lg:w-4 xl:w-[18px]"
              />
              <span className="font-normal text-xl   leading-6 lg:leading-7 text-darkGrey">
                {translate("visibility_and_ads")}
              </span>
            </p>
            <p className="flex flex-row items-center gap-2 lg:gap-3 xl:gap-[10px]">
              <Image
                src={yellowEllipse}
                alt="icon"
                height={13}
                width={13}
                className="w-3 lg:w-4 xl:w-[18px]"
              />
              <span className="font-normal text-xl  leading-6 lg:leading-7 text-darkGrey">
                {translate("market_listening")}
              </span>
            </p>
          </div>
          <Link
            href={"/request-demo"}
            className="py-4 lg:py-5 xl:py-7 px-7 lg:px-8 xl:px-10 text-xs lg:text-sm xl:text-xl leading-3 lg:leading-5 text-white font-bold bg-blue rounded-md lg:rounded-lg xl:rounded-xl place-self-start shadow"
          >
            <button type="button">{translate("button_text")}</button>
          </Link>
        </div>
      </div>

      <MarketingImage
        imageName={"Home-image.png"}
        alt="search-img"
        className={`hidden md:block lg:w-3/4 `}
        key="Home-image.png"
      />
    </section>
  );
}

export default Marketing;
